<template>
  <div>
    <breadcrumb :breadcrumb="breadcrumb" />
    <text-title :mainTitle="mainTitle" :subheading="subheading" />
    <form>
      <div class="form-line">
        <div class="textBox">
          <b class="red">*</b>
          <span class="line-text">分类名称：</span>
        </div>
        <el-input v-model="formData.categoryName" size="small" style="width: 280px" />
      </div>      
      <div class="form-line">
        <div class="textBox">
          <span class="line-text">分类描述：</span>
        </div>
        <el-input v-model="formData.categoryDes" size="small" style="width: 280px" />
      </div>          
    </form>
      <div class="form-btn-box">
        <button-confirm @confirm="confirm" />
        <button-cancel @cancel="cancel" />
      </div>        
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TextTitle from "../../../components/Text/TextTitle";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import { getObjectURL } from "../../../utils/toBase64";
import { bus } from "../../../utils/bus";
import { api } from "../../api/Material";
import { nError, nSuccess } from "../../../utils/notice";
import { errorHandler } from "../../../utils/errorHandler";
export default {
  components: {
    ButtonCancel,
    ButtonConfirm,
    TextTitle,
    Breadcrumb
  },
  name: "material-category-modify",
  data() {
    return {
      breadcrumb: [
        {
          value: "物资管理",
          name: "material-category-manage"
        },
        {
          value: "物资类目"
        }
      ],
      mainTitle: "修改类目",
      subheading: "",
      formData: {
        categoryName: "",
        categoryDes: ""
      }
    };
  },
  created() {
    this.getCategoryByCode();
  },
  methods: {
    getCategoryByCode() {
      this.$axios
        .get(`${api.getCategoryByCode}/${this.$route.params.id}`, {})
        .then(res => {
          console.log(res);
          this.formData = res.data.data;
        })
        .catch(errorHandler("查询失败"));
    },
    confirm() {
      if (!this.formData.categoryName) {
        nError("请输入分类名称");
        return false;
      }
      this.$axios
        .post(api.updateCategory, this.formData)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.$router.push({
              name: "material-category-manage"
            });
          }
        })
        .catch(errorHandler("修改失败"));
    },
    cancel() {
      this.$router.push({
        name: "material-category-manage"
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/view/MaterialManagement/MaterialCategory/MaterialCategoryModify.vue